module.exports =
  accepted:   [String]
  value:      "color"
